// extracted by mini-css-extract-plugin
export default {"commentItemContainer":"commentItem_commentItemContainer__GriLV"};